import { render, staticRenderFns } from "./AdUnits.vue?vue&type=template&id=2f667806&scoped=true"
import script from "./AdUnits.vue?vue&type=script&lang=js"
export * from "./AdUnits.vue?vue&type=script&lang=js"
import style0 from "./AdUnits.vue?vue&type=style&index=0&id=2f667806&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f667806",
  null
  
)

export default component.exports